export default "__VITE_ASSET__BCBVjWxQ__"